import { PropsWithChildren, ReactNode } from "react";
import { FaCaretDown } from "react-icons/fa";

import { cn } from "@bentolabs/kit/utils";

import { Collapsible } from "shared/ui/collapsible";

type Props = {
  className?: string;
  slot?: ReactNode;
  feeInUSD?: string | undefined;
};

export const TransactionInfo = ({
  slot,
  children,
  className,
}: PropsWithChildren<Props>) => {
  return (
    <Collapsible className={cn("overflow-hidden rounded-[18px]", className)}>
      <Collapsible.Trigger asChild className="w-full select-none">
        <button
          className={cn(
            "bg-nobel/5 text-nobel/70 flex cursor-pointer flex-wrap items-center justify-between p-4.5 outline-hidden",
            "group-data-[state=open]:border-b group-data-[state=open]:border-b-white/5"
          )}
        >
          {slot}
          {children && <FaCaretDown className="ml-1 size-4" />}
        </button>
      </Collapsible.Trigger>

      <Collapsible.Content>{children}</Collapsible.Content>
    </Collapsible>
  );
};
